export const Warning = () => (
  <svg
    width="69"
    height="69"
    viewBox="0 0 69 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="warning"
  >
    <path
      d="M48.9502 56.8316C48.5823 56.8316 48.2933 57.1206 48.2933 57.4885C48.2933 57.8563 48.5823 58.1453 48.9502 58.1453C49.318 58.1453 49.607 57.8563 49.607 57.4885C49.607 57.1206 49.318 56.8316 48.9502 56.8316Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9515 51.5768V43.6946"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.1575 35.8125C50.7108 34.998 49.87 34.4988 48.9504 34.4988C48.0309 34.4988 47.1901 34.998 46.7434 35.8125L33.4488 61.1143C33.0547 61.8762 33.081 62.7958 33.5277 63.5052C33.9743 64.2409 34.7888 64.6875 35.6558 64.6875H62.2188C63.0858 64.6875 63.874 64.2409 64.347 63.5052C64.7936 62.7695 64.8199 61.8499 64.4258 61.1143L51.1312 35.8125H51.1575Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17.4228 56.8316H25.305" stroke="#707475" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M25.3049 43.6946V56.8316"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5099 55.5179C11.142 55.5179 10.853 55.8069 10.853 56.1747C10.853 56.5426 11.142 56.8316 11.5099 56.8316C11.8777 56.8316 12.1667 56.5426 12.1667 56.1747C12.1667 55.8069 11.8777 55.5179 11.5099 55.5179Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.942 55.5179C4.57417 55.5179 4.28516 55.8069 4.28516 56.1747C4.28516 56.5426 4.57417 56.8316 4.942 56.8316C5.30984 56.8316 5.59885 56.5426 5.59885 56.1747C5.59885 55.8069 5.30984 55.5179 4.942 55.5179Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1385 36.4693C13.7707 36.4693 13.4817 36.7583 13.4817 37.1261C13.4817 37.494 13.7707 37.783 14.1385 37.783C14.5064 37.783 14.7954 37.494 14.7954 37.1261C14.7954 36.7583 14.5064 36.4693 14.1385 36.4693Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7064 36.4693C20.3385 36.4693 20.0495 36.7583 20.0495 37.1261C20.0495 37.494 20.3385 37.783 20.7064 37.783C21.0742 37.783 21.3632 37.494 21.3632 37.1261C21.3632 36.7583 21.0742 36.4693 20.7064 36.4693Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.0686 30.5577H10.8536C7.22784 30.5577 4.28516 33.5004 4.28516 37.1262C4.28516 40.752 7.22784 43.6946 10.8536 43.6946H33.1865"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1385 23.3323C13.7707 23.3323 13.4817 23.6213 13.4817 23.9892C13.4817 24.357 13.7707 24.646 14.1385 24.646C14.5064 24.646 14.7954 24.357 14.7954 23.9892C14.7954 23.6213 14.5064 23.3323 14.1385 23.3323Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7064 23.3323C20.3385 23.3323 20.0495 23.6213 20.0495 23.9892C20.0495 24.357 20.3385 24.646 20.7064 24.646C21.0742 24.646 21.3632 24.357 21.3632 23.9892C21.3632 23.6213 21.0742 23.3323 20.7064 23.3323Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9508 23.9892C48.9508 20.3634 46.0081 17.4207 42.3823 17.4207H10.8536C7.22784 17.4207 4.28516 20.3634 4.28516 23.9892C4.28516 27.615 7.22784 30.5577 10.8536 30.5577H41.0686"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1385 10.1954C13.7707 10.1954 13.4817 10.4844 13.4817 10.8522C13.4817 11.2201 13.7707 11.5091 14.1385 11.5091C14.5064 11.5091 14.7954 11.2201 14.7954 10.8522C14.7954 10.4844 14.5064 10.1954 14.1385 10.1954Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.7064 10.1954C20.3385 10.1954 20.0495 10.4844 20.0495 10.8522C20.0495 11.2201 20.3385 11.5091 20.7064 11.5091C21.0742 11.5091 21.3632 11.2201 21.3632 10.8522C21.3632 10.4844 21.0742 10.1954 20.7064 10.1954Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9508 10.8522C48.9508 9.11815 48.2677 7.43662 47.0328 6.20175C45.7979 4.96687 44.1427 4.28375 42.3823 4.28375H10.8536C7.22784 4.28375 4.28516 7.22643 4.28516 10.8522C4.28516 14.478 7.22784 17.4207 10.8536 17.4207H42.3823C46.0081 17.4207 48.9508 14.478 48.9508 10.8522Z"
      stroke="#707475"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
